export default __webpack_public_path__ + "static/media/Ballroll_00267.fc793953.png";